import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getCoupleDetails } from "../redux/marriageSlice";

const MustHavePurchase = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const checkGuests = async() => {
    const response = await dispatch(getCoupleDetails());
    const totalGuests = response?.payload?.total_guests || 0;
    if (totalGuests===0) {
      navigate("/package/purchase");
    }
  }

  useEffect(()=>{
    checkGuests();
  }, [dispatch]);

  return <></>;
}

export default MustHavePurchase;
